import { faArrowsUpDownLeftRight, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import TaskItem from "./TaskItem";
import { useDispatch, useSelector } from "react-redux";
import { useDrag, useDrop } from "react-dnd";
import BoardModal from "./BoardModal";
import "./Index.css"
import TaskModal from "./TaskModal";
import ErrorModal from "../../../components/ui/modal/ErrorModal";
import { orderChange as orderChangeBoard } from '../../../reducers/models/board/boardProjectList'
import axios from "axios";
import { Modal } from "react-bootstrap";
import TaskModalAdd from "../../../components/modal/TaskModalAdd";
import AvatarRound from "../../../components/AvatarRound";
import ErrorAdd from "../../../util/ErrorAdd";

function BoardItem({ model, projectSelected, index, refHeader }) {

    const id_object = 3;
    const dispatch = useDispatch()

    const stateSize = useSelector((state) => state.size);
    const [hightHeader, setHightHeader] = useState(61);
    const [idRole, setIdRole] = useState(2);//По умолчанию пользователь

    const listTask = useSelector((state) => state.boardTaskList)
    const stateProject = useSelector((state) => state.projectList);
    const stateProjectList = useSelector((state) => state.boardProjectList)
    const stateData = useSelector((state) => state.data);
    const stateSetting = useSelector((state) => state.setting);//Настройки приложения
    const stateUserList = useSelector((state) => state.userList);

    const [boardModalShow, setBoardModalShow] = useState(false);
    const [taskModalShow, setTaskModalShow] = useState(false);
    const [errorModalShow, setErrorModalShow] = useState(false);
    const [errorText, setErrorText] = useState(false);


    useEffect(() => {
        setHightHeader(refHeader.current.clientHeight);
    }, []);


    useEffect(() => {
        if (stateSetting.companyService != null) {
            setIdRole(stateSetting.companyService.ID_Role);
        }
    }, [stateSetting.companyService]);


    function errorTextHandler(text) {
        setErrorText(text);
    }

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: "board_" + projectSelected,
        drop: () => ({
            model, //Передаем в useDrag
        }),
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(model_, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = model_.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            /*if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                console.log('3')
                return
            }*/
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action

            dispatch(orderChangeBoard({ dragIndex: dragIndex, hoverIndex: hoverIndex, idProject: projectSelected }));

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            model_.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: "board_" + projectSelected,
        item: () => {
            return { model, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {
                axios.post('/api_tracker/board/projectOrderChange', { ID_Project: projectSelected, Items: stateProjectList.list.filter(a => a.ID_Project === projectSelected).map((item) => { return { ID_Board: item.ID_Board, Order: item.Order } }) })
                    .then((res) => {

                    })
                    .catch((err) => {
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
    })
    const opacity = isDragging ? 0 : 1

    if (idRole === 0 || idRole === 1) {
        drag(drop(ref))
    }

    //ПЕРЕТАСКИВАНИЕ ЗАДАЧИ НА ДРУГУЮ ДОСКУ
    const [{ canDrop, isOver }, dropref] = useDrop({
        accept: "board_task_" + projectSelected,
        drop: () => ({
            ID_Board: model.ID, //Передаем в useDrag
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
        hover(model_, monitor) {

        }
    });

    /********************START ВЫБОР ОТВЕТСТВЕННОГО****************************/
    const [responibleLog, setResponibleLog] = useState(null);
    const [responibleLoading, setResponibleLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [responibleModalShow, setResponibleModalShow] = useState(false);

    //Изменит ответственного
    function responsibleChangeHandler(id_user, id_task) {
        setResponibleLoading(true);
        setResponibleLog(null);
        axios.post('/api_tracker/board/taskUpdateResponsible', { ID: id_task, ID_Responsible: id_user })
            .then((res) => {
                if (res.data.Status === 1) {
                    setResponibleModalShow(false);
                }
                else {
                    setResponibleLog(res.data.Error);
                }
                setResponibleLoading(false);
            })
            .catch((err) => {
                setResponibleLog('Неизвестная ошибка!');
                setResponibleLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function responsibleChangeModal(id_board_new, id_project, id_task) {

        //ПРИ ИЗМЕНЕНИИ ЛОГИКИ МЕНЯТЬ ЕЩЕ В CardUserOne -openChangeModal !!!
        setResponibleModalShow(true);
        setResponibleLoading(true);
        setTaskModel(listTask.list.filter(a => a.ID === id_task)[0]);

        //Настройка "Доска доступна для всех"
        const all_user_board = stateProjectList.list.filter(a => a.ID_Project === projectSelected & a.ID_Board === model.ID)[0].All_User;

        if (all_user_board === true) {

            //Настройка проекта "ДОСТУПНЫЕ ПОЛЬЗОВАТЕЛИ"
            const all_user_project = stateProject.list.filter(a => a.ID === projectSelected)[0].All_User;

            if (all_user_project === true) {
                setUsers(stateUserList.list.map(user => {
                    return { id_user: user.ID_User, user_name: user.Name_User, avatar: user.Avatar_Small }
                }))
            }
            else {
                var users = [];
                //Админы
                stateUserList.list.filter(a => a.ID_Role === 0 || a.ID_Role === 1).map(user => {
                    users.push({ id_user: user.ID_User, user_name: user.Name_User, avatar: user.Avatar_Small })
                })
                //Пользователи
                stateProject.listUser.filter(a => a.ID_Project === projectSelected).map(user => {
                    if (users.filter(a => a.id_user === user.ID_User).length === 0) {
                        users.push({
                            id_user: user.ID_User
                            , user_name: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Name_User
                            , avatar: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Avatar_Small
                        })
                    }
                })
                setUsers(users);
            }
            setResponibleLoading(prev => false);
        }
        else {
            setUsers(
                stateProjectList.listUser.filter(a => a.ID_Board === model.ID & a.ID_Project === projectSelected).map(user => {
                    return {
                        id_user: user.ID_User
                        , user_name: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Name_User
                        , avatar: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Avatar_Small
                    }
                })
            )
            setResponibleLoading(prev => false);
        }
    }
    //END Выбор ответственного
    /*********************END ВЫБОР ОТВЕТСТВЕННОГО*****************************/
    /*************************START ИЗМЕНЕНИЕ**********************************/
    const [modalEditShow, setModalEditShow] = useState(false);
    /**************************END ИЗМЕНЕНИЕ***********************************/
    /*************************START ДОБАВЛЕНИЕ*********************************/
    const [taskModel, setTaskModel] = useState(null);
    const [modalAddShow, setModalAddShow] = useState(false);
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);

    function addHandler(name) {
        setLoadingAdd(true);
        setLogAdd(null);

        axios.post('/api_tracker/board/taskAdd', { ID_Board: model.ID, ID_Project: projectSelected, Priority: 0, Name: name })
            .then((res) => {
                if (res.data.Status === 1) {
                    getNew(res.data.Data);
                }
                else {
                    setLogAdd(res.data.Error);
                    setLoadingAdd(false);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function getNew(id) {
        axios.get('/api_tracker/board/taskGet', { params: { ID: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setTaskModel(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setLoadingAdd(false);
                }
                else {
                    setLoadingAdd(false);
                    setLogAdd(res.Error);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /**************************END ДОБАВЛЕНИЕ**********************************/

    function editHandler(model) {
        setTaskModel(model);
        setModalEditShow(true);

        if (model.Viewed === false & model.ID_Responsible === stateSetting.user.ID) {
            axios
                .post("/api/board/taskView", { ID_Board_Task: model.ID })
                .then((res) => {

                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            {boardModalShow === true && model != null && (
                <BoardModal show={boardModalShow} onHide={() => setBoardModalShow(false)} model={model} projectSelected={projectSelected} />
            )}
            {modalEditShow == true && listTask.list.filter(a => a.ID === taskModel.ID).length > 0 && (
                <TaskModal show={modalEditShow} onHide={() => setModalEditShow(false)} model={listTask.list.filter(a => a.ID === taskModel.ID)[0]} id_board={model.ID} id_project={projectSelected} id_type_appointment={model.ID_Type_Appointment} board_id_type={model.ID_Type} />
            )}
            {modalAddShow === true && (
                <TaskModalAdd show={modalAddShow} idObject={id_object} onHide={() => setModalAddShow(false)} title='Добавление задачи' error={logAdd} loading={loadingAdd} updateHandler={addHandler} showProject={false} />
            )}
            {errorModalShow === true && (
                <ErrorModal show={errorModalShow} onHide={() => setErrorModalShow(false)} errorText={errorText} />
            )}
            {responibleModalShow == true && (
                <Modal show={responibleModalShow} onHide={() => setResponibleModalShow(false)} >
                    <Modal.Body>
                        <div className="fs-4 text-center">Выберите ответственного</div>
                        {responibleLoading === true ? (
                            <div className="loader_01"></div>
                        ) : (
                            <div className="block_users mb-15 mt-15">
                                {users.sort((a, b) => a.user_name > b.user_name ? 1 : -1).map((user) => (
                                    <div key={user.id_user} className="list_item mt-10" onClick={() => responsibleChangeHandler(user.id_user, taskModel.ID)}>
                                        <div><AvatarRound img={user.avatar} width={30} name={user.user_name} /></div>
                                        <div className="ml-5">
                                            <div className="title">{user.user_name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {responibleLog !== null && <div className="form_error text-center mt-15">{responibleLog}</div>}
                    </Modal.Body>
                </Modal >)
            }
            <div>
                <div className="board" style={{ backgroundColor: model.Color, opacity }} ref={ref} data-handler-id={handlerId} >
                    <div className="board-header">
                        <div className="board-header-left" style={{ lineHeight: "normal" }}>
                            <FontAwesomeIcon className="mr-3 opacity-75" icon={stateData.boardType.filter(a => a.id === model.ID_Type)[0].icon} />
                            {model.Name}
                            <div className="counter">{listTask.list.filter(a => a.ID_Board == model.ID & a.ID_Project == projectSelected & a.Archive === false).length} задач(и)</div>
                        </div>
                        <div className="board-header-right">
                            {idRole !== 2 && (
                                <>
                                    <button className="btn-square btn-hover-shine btn btn-sm" >
                                        <i><FontAwesomeIcon icon={faArrowsUpDownLeftRight} /></i>
                                    </button>
                                    <button className="btn-square btn-hover-shine btn btn-sm" onClick={() => setBoardModalShow(true)}>
                                        <i><FontAwesomeIcon icon={faEdit} /></i>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="board-body" style={{ maxHeight: stateSize.windowHeight - hightHeader - 220, overflow: 'auto' }}>
                        <div className="board_task_container"
                            ref={dropref}
                            style={{
                                width: "100%",
                                height: "100%",
                                minHeight: '100px',
                                padding: "4px",
                                border: isOver ? "dashed 1px black" : "  ",
                            }}
                        >
                            {listTask.list.filter(a => a.ID_Board == model.ID & a.ID_Project == projectSelected & a.Archive === false & a.filter_label === 0 & a.filter_user === 0).map((task, index) => (
                                <TaskItem
                                    key={task.ID}
                                    model={task}
                                    id_type_appointment={model.ID_Type_Appointment}
                                    id_bord_type={model.ID_Type}
                                    index={index}
                                    errorText={errorTextHandler}
                                    errorOnShow={() => setErrorModalShow(true)}
                                    errorOnHide={() => setErrorModalShow(false)}
                                    projectSelected={projectSelected}
                                    responibleModal={responsibleChangeModal}
                                    onClick={editHandler}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="board-footer">
                        <button key={-1} className="board_btn_add" onClick={() => setModalAddShow(true)}>
                            <i className="mr-5"><FontAwesomeIcon icon={faPlus} /></i>
                            Добавить задачу
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}
export default BoardItem;